module.exports = __webpack_public_path__ + "static/icon-marker-5bbe48b571fce4231b80ea305c21ba02.svg";